import React from 'react';
import { OPEN_AUTHORIZATION_PAGE_STATUSES } from 'src/common/Status/authorizationConstants';
import ServiceAuthorizationWorkqueue from './ServiceAuthorizationWorkqueue';

const OpenServiceAuthorizations = () => (
  <ServiceAuthorizationWorkqueue
    authorizationStatus={OPEN_AUTHORIZATION_PAGE_STATUSES}
    onlyConsentedPeople
    showTimeInQueue
  />
);

export default OpenServiceAuthorizations;
